import React from "react";

import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkSkullContainer {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkSkullContainer: IframeworkSkullContainer = {

    data: {
        "COMPONENTS": [
            {
                "id": "SkullMainContainer_desktop",
                "name": "SkullMainContainer_desktop",
                "type": "Container",
                "x": 0,
                "y": 0,
                "layout": false,
                "uimode": "desktop",
                "filterTypes": [],
                child: [
                    {
                        "name": "bg_skull_static_1",
                        "image": "small_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 760,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_selected_1",
                        "image": "small_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 760,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_static_2",
                        "image": "medium_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 842,
                        "y": 76,
                    },
                    {
                        "name": "bg_skull_selected_2",
                        "image": "medium_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 842,
                        "y": 76,
                    },

                    {
                        "name": "bg_skull_static_3",
                        "image": "large_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 941,
                        "y": 75,
                    },
                    {
                        "name": "bg_skull_selected_3",
                        "image": "large_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 941,
                        "y": 75,
                    },

                    {
                        "name": "bg_skull_static_4",
                        "image": "medium_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1035,
                        "y": 76,
                    },
                    {
                        "name": "bg_skull_selected_4",
                        "image": "medium_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1035,
                        "y": 76,
                    },

                    {
                        "name": "bg_skull_static_5",
                        "image": "small_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1125,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_selected_5",
                        "image": "small_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1125,
                        "y": 82,
                    },

                    {
                        "name": "skull_meter_fx_0",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_1",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_2",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_3",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_4",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },


                    {
                        "id": "skullGlowOnReel_0",
                        "name": "skullGlowOnReel_0",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": false,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_1",
                        "name": "skullGlowOnReel_1",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": false,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_2",
                        "name": "skullGlowOnReel_2",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_3",
                        "name": "skullGlowOnReel_3",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_4",
                        "name": "skullGlowOnReel_4",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },


                ]
            },
            {
                "id": "SkullMainContainer_mobile",
                "name": "SkullMainContainer_mobile",
                "type": "Container",
                "x": 100,
                "y": 1000,
                "layout": true,
                "uimode": "mobile",
                "filterTypes": [],
                child: [
                    {
                        "name": "bg_skull_static_1",
                        "image": "small_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 775,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_selected_1",
                        "image": "small_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 775,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_static_2",
                        "image": "medium_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 854,
                        "y": 76,
                    },
                    {
                        "name": "bg_skull_selected_2",
                        "image": "medium_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 854,
                        "y": 76,
                    },

                    {
                        "name": "bg_skull_static_3",
                        "image": "large_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 941,
                        "y": 75,
                    },
                    {
                        "name": "bg_skull_selected_3",
                        "image": "large_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 941,
                        "y": 75,
                    },

                    {
                        "name": "bg_skull_static_4",
                        "image": "medium_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1027,
                        "y": 76,
                    },
                    {
                        "name": "bg_skull_selected_4",
                        "image": "medium_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1027,
                        "y": 76,
                    },

                    {
                        "name": "bg_skull_static_5",
                        "image": "small_skull.png",
                        "type": "Image",
                        "visible": true,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1107,
                        "y": 82,
                    },
                    {
                        "name": "bg_skull_selected_5",
                        "image": "small_skull_selected.png",
                        "type": "Image",
                        "visible": false,
                        "width": 112,
                        "height": 112,
                        "anchor": [0.5, 0.5],
                        "x": 1107,
                        "y": 82,
                    },

                    {
                        "name": "skull_meter_fx_0",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_1",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_2",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_3",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },
                    {
                        "name": "skull_meter_fx_4",
                        "type": "Animation",
                        "width": 133,
                        "height": 263,
                        "image": "skull_meter_fx",
                        "parentLayer": "specialAnimationLayer",
                        "animationSpeed": 0.2,
                        "playing": false,
                        "loop": true,
                        "visible": false,
                        // "scae"
                        "anchor": [0.5, 0.5],
                        "x": 1170,
                        "y": 800,
                        "animations": {
                            "anim": "skull_meter_fx",
                        },
                    },


                    {
                        "id": "skullGlowOnReel_0",
                        "name": "skullGlowOnReel_0",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": false,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_1",
                        "name": "skullGlowOnReel_1",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": false,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_2",
                        "name": "skullGlowOnReel_2",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_3",
                        "name": "skullGlowOnReel_3",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },
                    {
                        "id": "skullGlowOnReel_4",
                        "name": "skullGlowOnReel_4",
                        "type": "Spine",
                        "x": 0,
                        "y": 0,
                        "width": 228,
                        "height": 228,

                        "visible": false,
                        "anchor": [0, 0],
                        "spinedata": {
                            "spinename": "btnGlow",
                            "animationname": "fx_glow_blue",
                            "loop": true,
                            "timeScale": 0.9

                        },
                        "parentLayer": "specialAnimationLayer",
                    },


                ]
            },

        ]
    }

};

export const SkullContainerConfigurationContext = React.createContext(
    {}
);